<template>
  <v-expansion-panels accordion class="mt-5" v-model="panel">
    <v-expansion-panel
      v-for="(pendampingan_ke, index) in Object.keys((meta && meta.pendampingan) || {})"
      :key="index"
      v-model="panel"
      @click="onChangePendampinganKe(pendampingan_ke)"
    >
      <v-expansion-panel-header class="px-0 py-1">
        <template v-slot:actions>
          <v-icon color="primary">
            $expand
          </v-icon>
        </template>
        <template v-slot:default="{ open }">
          <v-list>
            <v-list-item class="px-0">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-calendar</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0 px-1">
                <v-row>
                  <v-col cols="12" lg="6">
                    <div class="body-2 grey--text">Bulan Pelaksanaan</div>
                    <div class="body-1 black--text font-weight-medium">
                      {{ $getDeepObj(meta, `pendampingan.${pendampingan_ke}`) }}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div class="body-2 grey--text">Status Laporan</div>
                    <v-chip
                      :color="status[laporans[pendampingan_ke] ? laporans[pendampingan_ke]['is_lengkap'] : -1]['color']"
                      class="white--text"
                    >
                      {{ status[laporans[pendampingan_ke] ? laporans[pendampingan_ke]['is_lengkap'] : -1]['label'] }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-auto text-right info--text font-weight-medium">
                    <div v-if="open"> Tampilkan Ringkas <v-icon right>mdi-down</v-icon> </div>
                    <div v-else> Tampilkan Laporan <v-icon right>mdi-down</v-icon> </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="yellow lighten-5">
        <v-list class="yellow lighten-5">
          <v-list-item>
            <v-list-item-content>
              <div class="body-1 font-weight-medium">Gambaran Umum Perkembangan Sekolah Penggerak</div>
              <v-list class="yellow lighten-5">
                <v-list-item v-for="id in 3" :key="id" class="px-0">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" lg="6" class="my-auto body-2">
                        <span class="font-weight-medium">Urutan {{ id }}</span> topik yang banyak dibicarakan dalam PMO
                        Level Sekolah
                        <div v-if="id > 1"><em class="orange--text">(opsional)</em></div>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <div class="body-2 grey--text">Status Laporan</div>
                        <v-chip
                          :color="status[getStatusLaporanProgres(pendampingan_ke, id)]['color']"
                          class="white--text"
                        >
                          {{ status[getStatusLaporanProgres(pendampingan_ke, id)]['label'] }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" lg="3" class="my-auto">
                        <div class="yellow--text text--lighten-5 body-2">Aksi</div>
                        <v-btn
                          class="text-capitalize"
                          depressed
                          color="primary"
                          :disabled="!isEditLaporan(pendampingan_ke, id)"
                          @click="onEditLaporan('progres-psp', pendampingan_ke, id)"
                        >
                          <v-icon left>
                            {{
                              (meta.binaan && meta.jadwal && meta.jadwal[pendampingan_ke]) ||
                              !$isObject(laporans[pendampingan_ke])
                                ? 'mdi-pencil'
                                : 'mdi-eye'
                            }}
                          </v-icon>
                          {{
                            (meta.binaan && meta.jadwal && meta.jadwal[pendampingan_ke]) ||
                            !$isObject(laporans[pendampingan_ke])
                              ? 'Lengkapi'
                              : 'Lihat'
                          }}
                          Laporan
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="12" lg="6" class="my-auto">
                  <div class="body-1 font-weight-medium">Perkembangan Pendampingan FSP</div>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-2 grey--text">Status Laporan</div>
                  <v-chip :color="status[getStatusLaporanProgres(pendampingan_ke, 'fsp')]['color']" class="white--text">
                    {{ status[getStatusLaporanProgres(pendampingan_ke, 'fsp')]['label'] }}
                  </v-chip>
                </v-col>
                <v-col cols="12" lg="3" class="my-auto">
                  <div class="yellow--text text--lighten-5 body-2">Aksi</div>
                  <v-btn
                    class="text-capitalize"
                    depressed
                    color="primary"
                    :disabled="
                      (!$getDeepObj(meta, `jadwal.${pendampingan_ke}`) || !meta.binaan) &&
                        !$isObject(laporans[pendampingan_ke])
                    "
                    @click="onEditLaporan('progres-fsp', pendampingan_ke)"
                  >
                    <v-icon left>
                      {{
                        (meta.binaan && meta.jadwal[pendampingan_ke]) || !$isObject(laporans[pendampingan_ke])
                          ? 'mdi-pencil'
                          : 'mdi-eye'
                      }}
                    </v-icon>
                    {{
                      (meta.binaan && meta.jadwal[pendampingan_ke]) || !$isObject(laporans[pendampingan_ke])
                        ? 'Lengkapi'
                        : 'Lihat'
                    }}
                    Laporan
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'KoordinatorLaporanProgres',
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    laporans: {
      type: Object,
      default: () => {},
    },
    laporansProgres: {
      type: Object,
      default: () => {},
    },
    form: {
      type: String,
      default: '',
    },
    akunInstansiId: {
      default: '',
    },
    pendampinganTahun: {
      type: [String, Number],
      default: 2022,
    },
  },
  data() {
    return {
      pendampinganKe: null,
      loaded: true,
      panel: null,
    };
  },
  computed: {},
  methods: {
    reset() {
      this.panel = 0;
    },

    getStatusLaporanProgres(pendampinganKe, id) {
      const laporan = this.laporans[pendampinganKe] || {};
      const laporanProgres = laporan['psp_kp_pa_koordinator_laporan_progreses'] || [];
      const status = laporan.status_progres || {};

      let key = id;
      if (id !== 'fsp') {
        key = `psp-topik-${id}`;
      }

      if (id !== 'fsp' && !laporanProgres[id - 1]) {
        return -1;
      }

      return status[`progres-${key}`] ? 1 : 0;
    },

    isEditLaporan(pendampingan_ke, id) {
      const laporanProgres = this.laporansProgres[pendampingan_ke] || {};
      const laporanProgresKe = laporanProgres[id - 1];

      if (this.$isObject(laporanProgresKe || {})) {
        return true;
      }

      return !(
        !this.$getDeepObj(this.meta, `jadwal.${pendampingan_ke}`) ||
        !this.meta.binaan ||
        (id > 1 && !laporanProgres[id - 2])
      );
    },

    onChangePendampinganKe(pendampinganKe) {
      this.pendampinganKe = null;
      this.$emit('pendampingan', pendampinganKe);
    },

    onEditLaporan(form, pendampinganKe, progresId) {
      if (this.akunInstansiId) {
        this.onViewLaporan(form, pendampinganKe, progresId);
        return;
      }

      this.$emit('laporan', { pendampinganKe, progresId, form });
    },

    onViewLaporan(form, pendampinganKe, progresId) {
      this.$emit('laporan', { pendampinganKe, progresId, form, isPreview: true });
    },
  },
  watch: {
    'meta.pendampingan_ke': function(pendampinganKe) {
      this.pendampinganKe = pendampinganKe;
      this.loaded = true;
    },
  },
};
</script>

<style scoped></style>
